// Global WeTravel loading styles
const WeTravelStyles = () => (
  <style>{`
    @keyframes wtSpin {
      to { transform: rotate(360deg); }
    }
    @keyframes wtFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes wtPulse {
      0%, 100% { opacity: 0.4; transform: scaleX(1); }
      50% { opacity: 1; transform: scaleX(1.5); }
    }
    /* WeTravel embedded modal styles */
    .wetravel-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(30, 25, 22, 0.97);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: wtFadeIn 0.3s ease;
    }
    .wetravel-modal-content {
      position: relative;
      width: 95%;
      max-width: 900px;
      height: 90vh;
      max-height: 700px;
      background: white;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
    }
    .wetravel-modal-close {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #F5F0E8;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #3F2A24;
      z-index: 10;
      transition: all 0.2s;
    }
    .wetravel-modal-close:hover {
      background: #3F2A24;
      color: #F5F0E8;
    }
    .wetravel-modal-iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  `}</style>
);

// Loading overlay component for WeTravel
const WeTravelLoadingOverlay = ({ isVisible, loadingTitle, loadingSubtitle }) => {
  if (!isVisible) return null;
  
  return (
    <div className="wetravel-loading-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(245, 240, 232, 0.97)',
      zIndex: 9999,
      animation: 'wtFadeIn 0.3s ease'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        color: '#3F2A24',
        fontFamily: "'Cormorant Garamond', serif",
        textAlign: 'center',
        padding: '40px'
      }}>
        <div style={{
          fontSize: '28px',
          fontWeight: 500,
          letterSpacing: '0.1em'
        }}>{loadingTitle}</div>
        <div style={{
          width: '60px',
          height: '2px',
          background: '#C5A059',
          animation: 'wtPulse 1.5s ease-in-out infinite'
        }}></div>
        <div style={{
          fontSize: '14px',
          color: '#5C4A3D',
          letterSpacing: '0.15em',
          textTransform: 'uppercase'
        }}>{loadingSubtitle}</div>
      </div>
    </div>
  );
};

export { WeTravelStyles, WeTravelLoadingOverlay };
